module.exports = __webpack_public_path__ + "img/inge-v6-3.f26a8a81.png";